module.exports = __webpack_public_path__ + "static/media/cu-boulder.411949fe.svg";